module.exports = __webpack_public_path__ + "img/hero-3.1859f78b.jpg";